import {useEffect, useState} from "react";

export default function SwiperContainerHandler({
                                                   swiperInitialClass = "",
                                                   swiperClasses = "",
                                                   initialParams = {},
                                                   dependencies,
                                                   children,
                                                   ...otherProps
                                               }) {

    const [el, setEl] = useState(null);
    useEffect(() => {

        const swiperEl = document.querySelector(`.${swiperInitialClass}`);

        Object.assign(swiperEl, initialParams)

        swiperEl.initialize();
        setEl(swiperEl);

    }, []); // eslint-disable-line

    useEffect(() => {
        if (dependencies && el) {
            try {
                el.swiper.update()
            } catch (e) {
                console.log("Error")
            }
        }
        // eslint-disable-next-line
    }, [dependencies]);


    return (
        <swiper-container init="false" class={`${swiperInitialClass} ${swiperClasses}`} {...otherProps}>
            {children}
        </swiper-container>
    )
}
